import { reduxKey } from './constants';
export var LiveNotificationType;
(function (LiveNotificationType) {
    LiveNotificationType["COMMENTS"] = "comments";
    LiveNotificationType["REPLIES"] = "replies";
    LiveNotificationType["MENTIONS"] = "mentions";
    LiveNotificationType["ACTIVITY"] = "activity";
})(LiveNotificationType || (LiveNotificationType = {}));
//# sourceMappingURL=types.js.map